import React from "react";
import Radium from "radium";
import { connect } from "react-redux";
import Header from "../Header/index";
import EmployerHeader from "../EmployerHeader/index";
import Footer from "../Footer/index";
import Main from "../../../Main";
import "./index.css";
import BackToTop from "../BackToTop/index";
import { Loader } from "../../Shared";

const showEmployer = (props) => {
  if (props.user && props.user.role !== "employer") return false;
  return (
    (props.user && props.user.role === "employer") ||
    ["/profiles", "/employers", "/products", "/employer-signup"].some((path) =>
      window.location.pathname.includes(path)
    )
  );
};

const DefaultLayout = (props) => (
  <>
    {showEmployer(props) ? (
      <EmployerHeader {...props} />
    ) : (
      <Header {...props} />
    )}
    <Main {...props} />
    <Footer {...props} />
    <BackToTop />
    <Loader />
  </>
);

const mapStateToProps = (state) => ({
  user: state.userByToken.user,
  pending: state.userByToken.pending,
});

export default connect(mapStateToProps)(Radium(DefaultLayout));
